module.exports = __webpack_public_path__ + "img/combo.82cd4752.png";